export default "__VITE_ASSET__D2sxepFr__"